<script lang="ts">
    import {MessageStore} from "../../../store/MessageStore";
    import {tick} from "svelte";
    import {ValueUtil} from "../../../lib/Common/Value/ValueUtil";
    import {ImagePathConfig} from "../../../ImagePathConfig";
    import ConfirmMessageType = MessageStore.ConfirmMessageType;


    $: confirmMessage = MessageStore.confirmMessage;


    $: isShow = (() => {
        if ($confirmMessage != null) {
            onShow();
            return true;
        } else {
            return false;
        }
    })();

    $: className = (() => {
        let classNameArray = ['confirm-message-view'];
        switch (type) {
            case MessageStore.ConfirmMessageType.information:
                classNameArray.push('information');
                break;
            case MessageStore.ConfirmMessageType.warning:
                classNameArray.push('warning');
                break;
            case MessageStore.ConfirmMessageType.danger:
                classNameArray.push('danger');
                break;
        }

        const className = classNameArray.join(' ');
        return className;
    })();

    async function onShow() {
        await tick();
        // console.log('onShow');
        if (isDisplayNegative) {
            // NegativeButton に focus
            negativeButtonElement.focus();
        } else {
            // PositiveButton に focus
            positiveButtonElement.focus();
        }
    }

    let type: ConfirmMessageType = null;
    let message: string = '';
    let description: string = '';
    let positiveMessage: string = '';
    let negativeMessage: string = '';
    let isDisplayNegative: boolean = false;
    let linkButton: MessageStore.LinkButtonData = null;

    let positiveButtonElement = null;
    let negativeButtonElement = null;

    $: {
        // message の更新
        const confirmMessageData = $confirmMessage;
        console.log({confirmMessageData});

        if (confirmMessageData != null) {
            if (confirmMessageData.getTime() != null) {
                type = confirmMessageData.type;
                message = confirmMessageData.message;
                description = confirmMessageData.description;
                linkButton = confirmMessageData.linkButton;
                positiveMessage = confirmMessageData.positiveMessage;
                negativeMessage = confirmMessageData.negativeMessage;
                if (confirmMessageData.negativeCallback != null) {
                    isDisplayNegative = true;
                } else {
                    isDisplayNegative = false;
                }

            }
        }
    }


    function onClickPositive() {
        const confirmMessageData = $confirmMessage;
        if (confirmMessageData != null) {
            confirmMessageData.positiveCallback();
        }
        confirmMessage.set(null);
    }

    function onClickNegative() {
        const confirmMessageData = $confirmMessage;
        if (confirmMessageData != null) {
            if (confirmMessageData.negativeCallback != null) {
                confirmMessageData.negativeCallback();
            }
        }
        confirmMessage.set(null);
    }


    function onClickBackground() {
        const confirmMessageData = $confirmMessage;
        if (confirmMessageData.negativeCallback != null) {
            return;
        }
        confirmMessage.set(null);
    }

</script>


<div class={className}
     class:show={isShow}
     on:click={onClickBackground}
>
    <div class="confirm-message" on:click|stopPropagation>
        <div class="message-area">
            {#if type === MessageStore.ConfirmMessageType.information}
                <img class="icon" alt="" src={ImagePathConfig.ConfirmMessage.information}/>
            {:else if type === MessageStore.ConfirmMessageType.warning}
                <img class="icon" alt="" src={ImagePathConfig.ConfirmMessage.warning}/>
            {:else if type === MessageStore.ConfirmMessageType.danger}
                <img class="icon" alt="" src={ImagePathConfig.ConfirmMessage.danger}/>
            {/if}
            { message }
        </div>
        {#if !ValueUtil.isEmpty(description) }
            <div class="description-area">
                { description }
            </div>
        {/if}
        {#if linkButton != null}
            <div class="link-button-area">
                <a href={linkButton.url} target="_blank" rel="noreferrer noopenner">
                    { linkButton.text }
                </a>
            </div>
        {/if}


        <div class="button-area"
             class:positive-only={!isDisplayNegative}
        >
            <button class="primary positive" on:click|stopPropagation={onClickPositive}
                    bind:this={positiveButtonElement}>
                { positiveMessage }
            </button>
            {#if isDisplayNegative }
                <button class="sub small negative" on:click|stopPropagation={onClickNegative}
                        bind:this={negativeButtonElement}>
                    { negativeMessage }
                </button>
            {/if}
        </div>

    </div>

</div>
<style lang="scss">
    .confirm-message-view {
        background-color: #0009;

        position: fixed;
        top: 0;
        left: 0;
        width: 100vw;
        height: 100vh;

        display: flex;
        align-items: center;
        justify-content: center;

        pointer-events: none;
        opacity: 0;
        transition-duration: 0.5s;

        z-index: var(--confirm-message-view-z-index);

        .confirm-message {
            border-color: #0003;
            border-width: 1px;
            border-style: solid;
            border-radius: 4px;

            padding: 24px;
            background-color: var(--background-color);

            transform: translateY(-50px);
            transition-duration: 0.5s;

            min-width: 300px;
            margin-left: 20px;
            margin-right: 20px;

            .message-area {
                font-weight: bold;
                display: flex;
                align-items: center;
                white-space: pre-wrap;

                .icon {
                    width: 3em;
                    margin-right: 1.5em;
                }
            }

            .description-area {
                font-size: 0.8em;
                margin-top: 8px;
                padding-left: 8px;
                padding-right: 8px;
                opacity: 0.8;
                white-space: pre-wrap;
                overflow-wrap: break-word;
            }

            .link-button-area {
                margin-top: 32px;
                margin-bottom: 32px;
                font-size: 0.5em;
                display: flex;
                align-items: center;
                justify-content: center;

                > a {
                    cursor: pointer;
                    text-decoration: underline;
                }
            }

            .button-area {
                margin-top: 3em;
                display: flex;
                align-items: center;
                justify-content: flex-end;
                gap: 1em;

                &.positive-only {
                    justify-content: center;
                }

            }

        }

        &.show {
            opacity: 1;
            pointer-events: all;

            .confirm-message {
                transform: translateY(0px);

            }
        }

        &.danger {
            .confirm-message {
                .button-area {
                    button {
                        &.positive {
                            background-color: var(--danger-color);
                            color: var(--danger-color-text);
                        }

                    }
                }
            }

        }
    }
</style>